"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coefficientOfVariation = exports.variance = exports.calculateAverage = exports.getIsBotTraffic = void 0;
const botKeywords_1 = require("./botKeywords");
const getIsBotTraffic = (userAgent) => {
    const lowerCaseUserAgent = userAgent.toLowerCase();
    const isBot = botKeywords_1.BOT_KEYWORDS.some((keyword) => lowerCaseUserAgent.includes(keyword));
    return isBot;
};
exports.getIsBotTraffic = getIsBotTraffic;
// Statistical helpers shared by the bot-detection behavior analyzers.
const calculateAverage = (values) => {
    if (values.length === 0) {
        return 0;
    }
    return values.reduce((total, value) => total + value, 0) / values.length;
};
exports.calculateAverage = calculateAverage;
const variance = (values) => {
    if (values.length === 0) {
        return 0;
    }
    const average = (0, exports.calculateAverage)(values);
    return (0, exports.calculateAverage)(values.map((value) => Math.pow((value - average), 2)));
};
exports.variance = variance;
// Standard deviation divided by the mean — a unitless measure of how much a set
// of values varies. Near zero means the values are almost identical (uniform).
const coefficientOfVariation = (values) => {
    const average = (0, exports.calculateAverage)(values);
    if (average === 0) {
        return 0;
    }
    return Math.sqrt((0, exports.variance)(values)) / average;
};
exports.coefficientOfVariation = coefficientOfVariation;
